import { Form, Select } from 'antd'
import { useEffect, useState } from 'react'
import { useUpdateRegistration } from '@BUP/hooks/registration/useUpdateRegistration'
import { useTranslation } from 'react-i18next'
import { useCreateRegistration } from '@BUP/hooks/registration/useCreateRegistration'
import ButtonComponent from '@BUP/components/Generics/Buttons/button-component'
import styles from './edit-teacher-form.module.scss'

const EditTeacherForm = ({
  selectedUser,
  courses,
  setStateModal,
  isMultiCourse
}) => {
  const hasRegistration = !!selectedUser.registrationId
  const i18n = useTranslation()
  const [form] = Form.useForm()
  const [, forceUpdate] = useState()
  const [selectedCourse, setSelectedCourse] = useState(
    selectedUser.courseId
  )
  const userName = selectedUser.name
  const { updateRegistration, updateLoading } = useUpdateRegistration(userName)

  const { createRegistration, loadingRegistration } = useCreateRegistration()
  const { Option } = Select
  const handleSelectCourse = e => {
    setSelectedCourse(e)
  }

  const tag = ['course:role:main-teacher']

  const onSubmitForm = async () => {
    if (hasRegistration) {
      const registration = await updateRegistration(selectedUser.registrationId, selectedCourse)
      if (registration) {
        setStateModal(false)
      }
    } else {
      const registration = await createRegistration(selectedUser.key, selectedCourse, tag)
      if (registration) {
        setStateModal(false)
      }
    }
  }

  useEffect(() => {
    forceUpdate()
  }, [])

  return (
    <Form
      form={form}
      onFinish={onSubmitForm}
    >
      {!isMultiCourse && (
        <Form.Item
          initialValue={selectedUser.course}
          label={i18n.t('common.resources.course.label')}
        >
          <Select
            style={{ width: 200 }}
            defaultValue={selectedUser.course}
            onChange={handleSelectCourse}
          >
            {courses && courses.length
              ? courses.map(elem => (
                <Option
                  key={`element-${elem.id}`}
                  value={elem.id}
                >
                  {elem.name}
                </Option>
              ))
              : null}
          </Select>
        </Form.Item>
      )}
      <Form.Item>
        <div className={styles.button_wrapper}>
          <ButtonComponent
            buttonText={i18n.t('common.resources.generic.actions.edit.submit')}
            htmlType='submit'
            colorType='secondary'
            shape='round'
            loading={updateLoading || loadingRegistration}
          />
        </div>
      </Form.Item>
    </Form>
  )
}

export default EditTeacherForm
